import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const GetObservationDocument = gql`
  query GetObservation($id: String!) {
    observation(id: $id) {
      id
      code {
        coding {
          system
          code
          display
        }
      }
      extension {
        url
        valueString
        valueAnnotation {
          text
        }
      }
      component {
        code {
          coding {
            code
            system
            display
          }
        }
        valueString
        valueCodeableConcept {
          coding {
            code
            system
            display
          }
        }
        valueQuantity {
          value
          system
          code
        }
      }
      effectiveDateTime
      status
      resourceType
      meta {
        tag {
          system
          code
        }
        lastUpdated
        versionId
      }
      subject {
        reference
      }
    }
  }
`;

/**
 * __useGetObservationQuery__
 *
 * To run a query within a React component, call `useGetObservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObservationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetObservationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetObservationQueryResponse,
    GetObservationQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetObservationQueryResponse,
    GetObservationQueryVariables
  >(GetObservationDocument, baseOptions);
}
export function useGetObservationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetObservationQueryResponse,
    GetObservationQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetObservationQueryResponse,
    GetObservationQueryVariables
  >(GetObservationDocument, baseOptions);
}
export type GetObservationQueryHookResult = ReturnType<
  typeof useGetObservationQuery
>;
export type GetObservationLazyQueryHookResult = ReturnType<
  typeof useGetObservationLazyQuery
>;
export type GetObservationQueryResult = ApolloReactCommon.QueryResult<
  GetObservationQueryResponse,
  GetObservationQueryVariables
>;
export type GetObservationQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;

export type GetObservationQueryResponse = {
  __typename: 'Query';
  observation?: Types.Maybe<{
    __typename: 'Observation';
    id?: Types.Maybe<string>;
    effectiveDateTime?: Types.Maybe<string>;
    status?: Types.Maybe<Types.ObservationStatus>;
    resourceType: Types.ObservationResourceType;
    code?: Types.Maybe<{
      __typename: 'CodeableConcept';
      coding?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
          display?: Types.Maybe<string>;
        }>
      >;
    }>;
    extension?: Types.Maybe<
      Array<{
        __typename: 'Extension';
        url?: Types.Maybe<string>;
        valueString?: Types.Maybe<string>;
        valueAnnotation?: Types.Maybe<{
          __typename: 'Annotation';
          text?: Types.Maybe<string>;
        }>;
      }>
    >;
    component?: Types.Maybe<
      Array<{
        __typename: 'ObservationComponent';
        valueString?: Types.Maybe<string>;
        code?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              code?: Types.Maybe<string>;
              system?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
        valueCodeableConcept?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              code?: Types.Maybe<string>;
              system?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
        valueQuantity?: Types.Maybe<{
          __typename: 'Quantity';
          value?: Types.Maybe<number>;
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
        }>;
      }>
    >;
    meta?: Types.Maybe<{
      __typename: 'Meta';
      lastUpdated?: Types.Maybe<string>;
      versionId?: Types.Maybe<string>;
      tag?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
        }>
      >;
    }>;
    subject?: Types.Maybe<{
      __typename: 'Reference';
      reference?: Types.Maybe<string>;
    }>;
  }>;
};
